import * as _ from 'lodash';

import { api } from '../axiosConfig';
import {surveysURL, surveyEmailSchedule, samplesURL, resendSurveyEmailSchedule} from "../Utils/urls";

export class SurveysAPI {
    static checkVerisoulEnabled(id: string, partnerId?: string, userId?: string) {
        const query = partnerId
            ? `?partnerId=${encodeURIComponent(partnerId)}`
            : (userId ? `?userId=${encodeURIComponent(userId)}` : '');
        const url = `${surveysURL}/checkVerisoulEnabled/${id}${query}`;
        return api.get(url)
            .then((res) => {
                return _.get(res, 'data.data.verisoul', _.get(res, 'data.verisoul', false));
            })
            .catch(() => false);
    }

    static getAll(
        limit : any,
        pagenumber: number,
        payload: { [key: string]: any },
        offset = 0,
    ): Promise<any[]> {
        return api.post(`${surveysURL}/getAll/${limit}/${pagenumber}`, payload).then((res) => {  
            return _.get(res, 'data', []);
        });
    }

    static create(payload: { [key: string]: any }): Promise<any> {
        return api.post(`${surveysURL}/create`, payload)
            .then((res) => {
                return _.get(res, 'data.data', {});
            });
    }

    static getOne(
        id : string
    ): Promise<any[]> {
        return api.post(`${surveysURL}/getOne/${id}`, {})
        .then((res) => {
            return _.get(res, 'data', {});
        });
    }

    static getOneDetails(
        id : string,
        limit : any,
        pagenumber: number,
    ): Promise<any[]> {
        return api.post(`${surveysURL}/getOneDetails/${id}/${limit}/${pagenumber}`, {})
        .then((res) => {
            return _.get(res, 'data', {});
        });
    }

    static getpantnerdetailsmain(
        id : string
    ): Promise<any[]> {
        return api.post(`${surveysURL}/getpantnerdetailsmain/${id}`, {})
        .then((res) => {
            return _.get(res, 'data.data', {});
        });
    }

    static getOneDXPanelOnly(
        id : string
    ): Promise<any[]> {
        return api.post(`${surveysURL}/getOneDXPanelOnly`, {id})
        .then((res) => {
            return _.get(res, 'data.data', {});
        });
    }

    static getAllPartnerUsersexport(
        id : string
    ): Promise<any[]> {
        return api.post(`${surveysURL}/getAllPartnerUsersexport/${id}`, {})
        .then((res) => {
            return _.get(res, 'data.data', {});
        });
    }

    static getSurveyDetailsExport(
        id : string
    ): Promise<any[]> {
        return api.post(`${surveysURL}/getSurveyDetailsExport/${id}`, {})
        .then((res) => {
            return _.get(res, 'data', {});
        });
    }

    static update(id: string, payload: { [key: string]: any }): Promise<any> {
        return api.post(`${surveysURL}/update/${id}`, payload)
            .then((res) => {
                return _.get(res, 'data.data', {});
            });
    }

    static deleteOne(id: string): Promise<any> {
        return api.post(`${surveysURL}/delete/${id}`, {})
            .then((res) => {
                return _.get(res, 'data.data', {});
            });
    }

    static addPartners(payload: { [key: string]: any }): Promise<any> {
        return api.post(`${surveysURL}/add-partners`, payload)
            .then((res) => {
                return _.get(res, 'data.data', {});
            });
    }



    static getAllTemplate(
        id: string,
        limit = 100000,
    ): Promise<any[]> {
        return api.post(`${surveysURL}/getAll-template/${id}/${limit}`, {})
        .then((res) => {
            return _.get(res, 'data.data', []);
        });
    }

    static createTemplate(payload: { [key: string]: any }): Promise<any> {
        return api.post(`${surveysURL}/create-template`, payload)
            .then((res) => {
                return _.get(res, 'data.data', {});
            });
    }

    static getOneTemplate(
        id : string
    ): Promise<any[]> {
        return api.post(`${surveysURL}/getOne-template/${id}`, {})
        .then((res) => {
            return _.get(res, 'data.data', {});
        });
    }

    static updateTemplate(id: string, payload: { [key: string]: any }): Promise<any> {
        return api.post(`${surveysURL}/update-template/${id}`, payload)
            .then((res) => {
                return _.get(res, 'data.data', {});
            });
    }

    static deleteOneTemplate(id: string): Promise<any> {
        return api.post(`${surveysURL}/delete-template/${id}`, {})
            .then((res) => {
                return _.get(res, 'data.data', {});
            });
    }



    static getAllEmailSchedule(
        id: string,
        limit = 100000,
    ): Promise<any[]> {
        return api.post(`${surveyEmailSchedule}/getAll/${id}/${limit}`, {})
        .then((res) => {
            return _.get(res, 'data.data', []);
        });
    }

    static createEmailSchedule(payload: { [key: string]: any }): Promise<any> {
        return api.post(`${surveyEmailSchedule}/create`, payload)
            .then((res) => {
                return _.get(res, 'data.data', {});
            });
    }

    static getOneEmailSchedule(
        id : string
    ): Promise<any[]> {
        return api.post(`${surveyEmailSchedule}/getOne/${id}`, {})
        .then((res) => {
            return _.get(res, 'data.data', {});
        });
    }

    static updateEmailSchedule(id: string, payload: { [key: string]: any }): Promise<any> {
        return api.post(`${surveyEmailSchedule}/update/${id}`, payload)
            .then((res) => {
                return _.get(res, 'data.data', {});
            });
    }

    static deleteEmailSchedule(id: string): Promise<any> {
        return api.post(`${surveyEmailSchedule}/delete/${id}`, {})
            .then((res) => {
                return _.get(res, 'data.data', {});
            });
    }

    static sendInviteNow(id: string): Promise<any> {
        return api.post(`${surveyEmailSchedule}/sendNow/${id}`, {})
            .then((res) => {
                return _.get(res, 'data.data', {});
            });
    }

    static downloadUsers(id: string): Promise<any> {
        return api.post(`${samplesURL}/getOneSampleAllUsers/${id}`, {})
            .then((res) => {
                return _.get(res, 'data.data', {});
            });
    }


    static panelistSurveys(id: string): Promise<any> {
        return api.post(`${surveysURL}/panelist-surveys/${id}`, {})
            .then((res) => {
                return _.get(res, 'data.data', {});
            });
    }

    static panelistOneSurvey(id: string): Promise<any> {
        return api.post(`${surveysURL}/panelist-one-surveys/${id}`, {})
            .then((res) => {
                return _.get(res, 'data.data', {});
            });
    }

    static GetUserOneAssignedSurveyCallback(payload: { [key: string]: any }): Promise<any> {
        return api.post(`${surveysURL}/GetUserOneAssignedSurveyCallback`, payload)
            .then((res) => {
                return _.get(res, 'data.data', {});
            });
    }

    // Read-only display data for the country panel end pages. The DX (admin) layer
    // records the hit; the panel page only renders the result. No DB writes.
    static getSurveyDisplayData(payload: { surveyId: string; userId: string }): Promise<any> {
        return api.post(`${surveysURL}/getSurveyDisplayData`, payload)
            .then((res) => {
                return _.get(res, 'data.data', {});
            });
    }

    static reportPanelistOutcomeToCountry(payload: { surveyId: string; userId: string; status: string; isPreScreenTerminated?: boolean }) {
        return api.post(`${surveysURL}/recordPanelistOutcome`, payload);
    }

    static reportPanelistOutcomeToAdmin(payload: { surveyId: string; userId: string; status: string; isPreScreenTerminated?: boolean }): Promise<any> {
        const adminBase = process.env.REACT_APP_ADMIN_API_URL;
        if (!adminBase) return Promise.resolve({});
        // Plain axios — must NOT go through the shared encrypted api instance.
        // If a top-level `import axios from 'axios'` already exists, use it.
        const rawAxios = require('axios').default;
        // Unwrap to the data payload (mirrors getSurveyDisplayDataPlain's
        // _.get(res, 'data.data', {}) pattern). Partner respondents get back
        // { url } here — the caller's .then redirects to it; panelist
        // respondents get nothing url-shaped, and the caller no-ops.
        return rawAxios.post(
            `${adminBase}/api/v1/surveys/GetUserOneAssignedSurveyCallback`,
            payload,
            { headers: { 'Content-Type': 'application/json' }, timeout: 5000 }
        ).then((res: any) => _.get(res, 'data.data', {}));
    }

    // Plain-axios variant of getSurveyDisplayData. Bypasses the shared `api`
    // instance (which wraps the body in {token: encryptData(...)} and demands
    // an authenticated userAuthId via the country backend's encryption
    // middleware). The thank-you pages are reachable WITHOUT a panelist login
    // (dummy-survey test flow, email-link recovery, etc.) — going through
    // the encrypted path always fails with "User not authorized" and then
    // the response interceptor's decryptData() crashes with
    // `"list" argument must be an Array of Buffers"` on the plain-JSON error
    // body. The country backend route is in `exemptedRoutes` AND
    // `encexception` so both request body and response body are plain JSON.
    static getSurveyDisplayDataPlain(payload: { surveyId: string; userId: string }): Promise<any> {
        const base = process.env.REACT_APP_BASE_URL_API || '';
        const rawAxios = require('axios').default;
        return rawAxios.post(
            `${base}${surveysURL}/getSurveyDisplayData`,
            payload,
            { headers: { 'Content-Type': 'application/json' }, timeout: 8000 }
        ).then((res: any) => _.get(res, 'data.data', {}));
    }

    // Plain (un-encrypted) lookup of a panelist's account language by userId.
    // Used by the already-attempted outcome page, which has a userid but no
    // surveyId. Route is in exemptedRoutes + encexception (plain JSON both ways).
    static getUserLanguagePlain(payload: { userId: string }): Promise<any> {
        const base = process.env.REACT_APP_BASE_URL_API || '';
        const rawAxios = require('axios').default;
        return rawAxios.post(
            `${base}${surveysURL}/getUserLanguage`,
            payload,
            { headers: { 'Content-Type': 'application/json' }, timeout: 8000 }
        ).then((res: any) => _.get(res, 'data.data', {}));
    }

    static surveyPartner(payload: { [key: string]: any }): Promise<any> {
        return api.post(`${surveysURL}/createSurveyPartnerUser`, payload)
            .then((res) => {
                return _.get(res, 'data.data', {});
            });
    }

    static userRespondentDashboardWeb(userId: any, language = 'en'): Promise<any> {
        return api.post(`${surveysURL}/userRespondentDashboardWeb/${userId}?language=${language}`, {})
            .then((res) => {
                return _.get(res, 'data.data', {});
            });
    }

    static adminRespondentDashboardWeb(): Promise<any> {
        return api.post(`${surveysURL}/adminRespondentDashboardWeb`, {})
            .then((res) => {
                return _.get(res, 'data.data', {});
            });
    }

    static partnerSurveyUsers(selectPartners, surveyId): Promise<any> {
        return api.post(`${surveysURL}/getAllPartnerUsers/${selectPartners}/${surveyId}`, {})
            .then((res) => {
                return _.get(res, 'data.data', []);
            });
    }

    static uploadBulkRewards(payload: { [key: string]: any }): Promise<any> {
        return api.post(`${surveysURL}/uploadBulkRewards`, payload)
            .then((res) => {
                return _.get(res, 'data.data', {});
            });
    }

    static fetchSurveyOverviewStatus(payload: { [key: string]: any }): Promise<any> {
        return api.post(`${surveysURL}/surveyOverviewStatus`, payload)
            .then((res) => {
                return _.get(res, 'data.data', {});
            });
    }
    // Note: resendSendNow endpoint not mounted in country backend - only available in admin portal
    static ResendReminderApi(payload: { [key: string]: any }): Promise<any> {
        return api.post(`${resendSurveyEmailSchedule}/resendsendNow`, payload)
            .then((res) => {
                // Return the response data directly
                return res.data;
            })
            .catch((error) => {
                // Handle the error appropriately
                console.error("Error in ResendReminderApi:", error);
                throw error; // Rethrow the error to be handled in the calling function
            });
    }


    static deletePartner(id: string): Promise<any> {
        const payload = {
            partnerId: id,
        };
        return api.post(`${surveysURL}/destroy-Partner`, payload)
            .then((res) => {
                return _.get(res, 'data.data', {});
            })
            .catch((error) => {
                console.error('Error deleting partner:', error.message);
                throw error; // Rethrow the error for further handling
            });
    }

    static surveysamplecount(surveyId: string, sampleId: string): Promise<any> {
        return api.post(`${surveysURL}/surveysamplecount`, {surveyId, sampleId, })
            .then((res) => {
                return _.get(res, 'data.data', {});
            })
            .catch((error) => {
                console.error('Error survey sample count:', error.message);
                throw error;
            });
    }

    static duplicatesurvey(payload: any): Promise<any> {
        return api.post(`${surveysURL}/duplicatesurvey`, payload)
            .then((res) => {
                return _.get(res, 'data.data', {});
            })
            .catch((error) => {
                console.error('Error duplicate survey:', error.message);
                throw error;
            });
    }

    static duplicatesurveyWithSameRedirects(payload: any): Promise<any> {
        return api.post(`${surveysURL}/duplicatesurveyWithSameRedirects`, payload)
            .then((res) => {
                return _.get(res, 'data.data', {});
            })
            .catch((error) => {
                console.error('Error duplicate survey for same redirects:', error.message);
                throw error;
            });
    }

    static testSurvey(payload: any): Promise<any> {
        return api.post(`${surveysURL}/testSurvey`, payload)
            .then((res) => {
                return _.get(res, 'data.data', {});
            })
            .catch((error) => {
                console.error('Error test survey:', error.message);
                throw error;
            });
    }

    static testuniqueLinks(payload: any): Promise<any> {
        return api.post(`${surveysURL}/testuniqueLinks`, payload)
            .then((res) => {
                return _.get(res, 'data.data', {});
            })
            .catch((error) => {
                console.error('Error test unique links :', error.message);
                throw error;
            });
    }

    static testuniqueLinksPartners(payload: any): Promise<any> {
        return api.post(`${surveysURL}/testuniqueLinksPartners`, payload)
            .then((res) => {
                return _.get(res, 'data.data', {});
            })
            .catch((error) => {
                console.error('Error test unique links partner :', error.message);
                throw error;
            });
    }

    static resendpartnerUserLinks(payload: any): Promise<any> {
        return api.post(`${surveysURL}/resendpartnerUserLinks`, payload)
            .then((res) => {
                return _.get(res, 'data.data', {});
            })
            .catch((error) => {
                console.error('Error test unique links partner :', error.message);
                throw error;
            });
    }

    static getMarketsOfSurvey(payload: any): Promise<any> {
        return api.post(`${surveysURL}/getMarketsOfSurvey`, payload)
            .then((res) => {
                return _.get(res, 'data.data', {});
            })
            .catch((error) => {
                console.error('Error get markets of survey :', error.message);
                throw error;
            });
    }

    static downloadPartnerUniqueLinks(payload: any): Promise<any> {
        return api.post(`${surveysURL}/downloadPartnerUniqueLinks`, payload)
            .then((res) => {
                return _.get(res, 'data.data', {});
            })
            .catch((error) => {
                console.error('Error download test unique links partner :', error.message);
                throw error;
            });
    }

    static getPartnerUsersexport(payload: any): Promise<any> {
        return api.post(`${surveysURL}/getPartnerUsersexport`, payload)
            .then((res) => {
                return _.get(res, 'data.data', {});
            })
            .catch((error) => {
                console.error('Error download test unique links partner :', error.message);
                throw error;
            });
    }

    static resendpartnerUsersDownload(payload: any): Promise<any> {
        return api.post(`${surveysURL}/resendpartnerUsersDownload`, payload)
            .then((res) => {
                return _.get(res, 'data.data', {});
            })
            .catch((error) => {
                console.error('Error download resend partner users :', error.message);
                throw error;
            });
    }

    static getLeftQuotaPoints(payload: any): Promise<any> {
        return api.post(`${surveysURL}/getLeftQuotaPoints`, payload)
            .then((res) => {
                return _.get(res, 'data.data', {});
            })
            .catch((error) => {
                console.error('Error left quota points :', error.message);
                throw error;
            });
    }

    static getPartnerTestIdsOnTheBasisOfStatus(payload: any): Promise<any> {
        return api.post(`${surveysURL}/getPartnerTestIdsOnTheBasisOfStatus`, payload)
            .then((res) => {
                return _.get(res, 'data.data', {});
            })
            .catch((error) => {
                console.error('Error in Ids :', error.message);
                throw error;
            });
    }

    static updateSurveyStatusOnly(payload: any): Promise<any> {
        return api.post(`${surveysURL}/updateSurveyStatusOnly`, payload)
            .then((res) => {
                return _.get(res, 'data.data', {});
            })
            .catch((error) => {
                console.error('Error in update status :', error.message);
                throw error;
            });
    }

    static pmListAPI(): Promise<any> {
        return api.post(`${surveysURL}/pmListAPI`, {})
            .then((res) => {
                return _.get(res, 'data.data', {});
            })
            .catch((error) => {
                console.error('Error in update status :', error.message);
                throw error;
            });
    }
    
}
